import React from "react";

import { GuestAccordionSection } from "./index";

interface IProps {
  places: server.dto.LegacyGuestlistPlace[]
  isSearching: boolean
}

class GuestAccordion extends React.Component<IProps> {
  public render(): JSX.Element {
    return (
      <div>
        {this.props.places.map((place) => (
          <GuestAccordionSection key={place.guestlistPlaceId} place={place} isSearching={this.props.isSearching} />
        ))}
      </div>);
  }
}

export default GuestAccordion;
